import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { gradientExpandableTextCollapseMask } from '../../../../../shared/style-settings'

export const useExpandableTextStyles = makeStyles((theme: Theme) =>
  createStyles({
    expandHolderClose: {
      maxHeight: 230,
      overflow: 'hidden',
      position: 'relative',
      '& > div': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: gradientExpandableTextCollapseMask,
      },
    },
    expandHolderOpen: {
      position: 'relative',
      paddingBottom: 30,
      '& > div': {
        background: 'none !important',
      },
    },
    bgState: {
      marginBottom: -20,
      background: 'none !important',
    },
    expandBtnBlock: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      textAlign: 'center',
      fontWeight: 700,
      cursor: 'pointer',
      color: theme.palette.primary.dark,
      '& *': {
        verticalAlign: 'middle',
      },
    },
  })
)
